<template>
    <div>

       <ComIndex  :orderType="5" exportTitle="青少年儿童培训订单"/>

    </div>
</template>

<script>
import ComIndex from '../commonIndex'
export default {
  components: {
    ComIndex
  },
  data () {
    return {

    }
  },
  created () {

  },
  methods: {

  }

}
</script>
<style  scoped>

</style>
